import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import { Button } from '@/components/ui/button';
import { Home, ArrowLeft } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

const NotFound = () => {
  const { t } = useLanguage();
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Helmet>
        <title>{t('notFound.title')} - Spawncore</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      
      <Navigation />
      
      <main className="flex-1 flex items-center justify-center px-4">
        <div className="text-center max-w-md fade-in">
          <h1 className="text-8xl font-bold mb-4 text-primary">404</h1>
          <h2 className="text-3xl font-semibold mb-4 text-foreground">{t('notFound.title')}</h2>
          <p className="text-lg text-muted-foreground mb-8">
            {t('notFound.description')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild size="lg">
              <Link to="/">
                <Home className="h-5 w-5 mr-2" />
                {t('notFound.home')}
              </Link>
            </Button>
            <Button variant="outline" size="lg" onClick={() => window.history.back()}>
              <ArrowLeft className="h-5 w-5 mr-2" />
              {t('notFound.back')}
            </Button>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default NotFound;
